import {
  SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL,
  SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL,
  SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  SET_CAPTAIN_DETAILS_FOR_ADMIN,
  SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN,
  SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN,
  SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN,
  SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN,
  SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN,
  CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL,
  DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  RESET_CAPTAIN_DETAILS_FOR_ADMIN,
  SET_CHANGE_MULTIPLE_ENTRIES_ERRORS,
  SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN,
  SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN,
  SET_SELECTED_AFFECTED_VIRTUAL_ENTRY,
  SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED,
  CHANGE_HIDE_CANCELLED_ENTRIES,
  CHANGE_HIDE_ARCHIVED_ENTRIES,
  SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL
} from './constants';

export const initialState = {
  balance: 0,
  captainEmail: '',
  captainId: '',
  captainName: '',
  captainFirstName: '',
  captainLastName: '',
  captainAddress1: '',
  captainAddress2: '',
  captainCity: '',
  captainState: '',
  captainCountry: '',
  captainZip: '',
  captainPhoneNumber: '',
  notes: '',
  changeMultipleEntriesErrors: '',
  payments: [],
  paymentEntries: [],
  paymentVirtualEvents: [],
  selectedBalance: 0,
  hasSelectedEntries: false,
  hasSelectedVirtualEntries: false,
  canChangeEntriesCaptain: false,
  selectedEntriesWithoutBalance: false,
  showNotesModal: false,
  showPaymentModal: false,
  showUpdateModal: false,
  hideCancelledEntries: true,
  hideArchivedEntries:true,
  tournaments: [],
  loadingTournaments: true,
  showCaptainEntryChangeCaptainModal: false,
  isNewCaptainOnSearch: false,
  affectedVirtualEntries: [],
  allAffectedVirtualEntriesSelected: false,
  validationMessages: null
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case RESET_CAPTAIN_DETAILS_FOR_ADMIN:
      return {
        ...state,
        ...initialState
      };
    case SET_CHANGE_MULTIPLE_ENTRIES_ERRORS: 
      return {
        ...state,
        changeMultipleEntriesErrors: payload
      };
    case CHANGE_HIDE_CANCELLED_ENTRIES: 
      return {
        ...state,
        hideCancelledEntries: payload,
        loadingTournaments: true
      };
      case CHANGE_HIDE_ARCHIVED_ENTRIES: 
      return {
        ...state,
        hideArchivedEntries: payload,
        loadingTournaments: true
      };
    case DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL:
      return {
        ...state,
        showUpdateModal: payload || initialState.showUpdateModal
      };
    case SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL:
      return {
        ...state,
        paymentVirtualEvents: payload || initialState.paymentVirtualEvents
      };
    case DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL:
      return {
        ...state,
        payments: state.payments.map(x => paymentReducer(x, {type, payload}))
      };
    case SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL:
      return {
        ...state,
        paymentEntries: payload || initialState.paymentEntries
      };
    case SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL:
      return {
        ...state,
        payments: payload || initialState.payments
      };
    case DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL:
      return {
        ...state,
        showNotesModal: payload || initialState.showNotesModal
      };
    case DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL: {
      return {
        ...state,
        showPaymentModal: payload || initialState.showPaymentModal
      };
    }
    case DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL: {
      const newPayload = {
        tournamentId: payload,
        anySelected: false
      };

      state.tournaments.forEach(t => {
        if(newPayload.anySelected) return;
        newPayload.anySelected = t.entries.some(entry => !!entry.selected)
          || t.virtualEvents.some(virtualEvent => !!virtualEvent.selected);
      });

      return {
        ...state,
        tournaments: state.tournaments.map(x => tournamentReducer(x, {type, payload: newPayload}))
      };
    }
    case SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN:
    case SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN:
    case SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN:
      return {
        ...state,
        tournaments: state.tournaments.map(x => tournamentReducer(x, {type, payload}))
      };
    case CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL: {
      let selectedBalance = 0;
      let hasSelectedEntries = false;
      let hasSelectedVirtualEntries = false;
      let canChangeEntriesCaptain = false;
      let selectedEntriesWithoutBalance = false;

      state.tournaments.forEach(t => {
        selectedBalance += t.entries
          .filter(entry => entry.selected)
          .reduce((sum, entry) => sum + entry.balanceDue, 0);
        selectedBalance += t.virtualEvents
          .filter(virtualEvent => virtualEvent.selected)
          .reduce((sum, virtualEvent) => sum + virtualEvent.balanceDue, 0);
          
        if (t.entries.filter(
            entry => entry.selected).length > 0)
          hasSelectedEntries = true;

        if (t.virtualEvents.filter(
            entry => entry.selected).length > 0)
          hasSelectedVirtualEntries = true;

        if (hasSelectedEntries && !hasSelectedVirtualEntries)
          canChangeEntriesCaptain = true;
          
        if (t.entries.filter(
            entry => entry.selected && entry.balanceDue == 0).length > 0 ||
            t.virtualEvents.filter(
            entry => entry.selected && entry.balanceDue == 0).length > 0)
          selectedEntriesWithoutBalance = true;
      });

      return {
        ...state,
        selectedBalance,
        hasSelectedEntries,
        hasSelectedVirtualEntries,
        changeMultipleEntriesErrors: '',
        canChangeEntriesCaptain,
        selectedEntriesWithoutBalance
      };
    }
    case SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN: {
      let tournaments = initialState.tournaments;

      if (payload) {
        // set default state on nested arrays
        tournaments = payload.map(x => ({
          ...x,
          selected: false,
          collapsed: false,
          entries: x.entries.map(y => ({
            ...y,
            selected: false,
            selectable: true,
            hasBalance:  y.balanceDue > 0
          })),
          virtualEvents: x.virtualEvents.map(z => ({
            ...z,
            selected: false,
            selectable: true,
            hasBalance:  z.balanceDue > 0
          }))
        }));
      }

      return {
        ...state,
        tournaments,
        loadingTournaments: false
      };
    }
    case SET_CAPTAIN_DETAILS_FOR_ADMIN: {
      return payload
        ? {
          ...state,
          captainName: payload.captainName || initialState.captainName,
          captainFirstName: payload.captainFirstName || initialState.captainFirstName,
          captainLastName: payload.captainLastName || initialState.captainLastName,
          captainEmail: payload.captainEmail || initialState.captainEmail,
          captainAddress1: payload.captainAddress1 || initialState.captainAddress1,
          captainAddress2: payload.captainAddress2 || initialState.captainAddress2,
          captainCity: payload.captainCity || initialState.captainCity,
          captainState: payload.captainState || initialState.captainState,
          captainCountry: payload.captainCountry || initialState.captainCountry,
          captainZip: payload.captainZip || initialState.captainZip,
          captainPhoneNumber: payload.captainPhoneNumber || initialState.captainPhoneNumber,
          captainId: payload.captainId || initialState.captainId,
          notes: payload.notes || initialState.notes
        }
        : state;
    }
    case SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN: {
      return {
        ...state,
        balance: payload || initialState.balance
      };
    }
    case SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN: {
      return {
        ...state,
        isNewCaptainOnSearch: payload 
      };
    }

    case HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN:
    case SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN: {
      return {
        ...state,
        showCaptainEntryChangeCaptainModal: payload 
      };
    } 
    case SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN: {
      const affectedVirtualEntries = payload;

      affectedVirtualEntries.filter(entry => entry.entryName !== null).forEach(entry => entry.selected = true);

      return {
        ...state,
        affectedVirtualEntries: affectedVirtualEntries
      };
    }

    case SET_SELECTED_AFFECTED_VIRTUAL_ENTRY: {
      const newAffectedVirtualEntries = state.affectedVirtualEntries.slice();
      const selectedEntry = newAffectedVirtualEntries.filter(entry => entry.virtualEntryId == payload.virtualEntryId)[0];

      if (selectedEntry) {
        selectedEntry.selected = payload.selected;
      }

      const newAllAffectedVirtualEntriesSelected = newAffectedVirtualEntries.every(entry => entry.selected);

      return {
        ...state,
        affectedVirtualEntries: newAffectedVirtualEntries,
        allAffectedVirtualEntriesSelected: newAllAffectedVirtualEntriesSelected
      };
    }

    case SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED: {
      const newAffectedVirtualEntries = state.affectedVirtualEntries.slice();
      const newAllAffectedVirtualEntriesSelected = !state.allAffectedVirtualEntriesSelected;

      newAffectedVirtualEntries.forEach(entry => entry.selected = newAllAffectedVirtualEntriesSelected);

      return {
        ...state,
        affectedVirtualEntries: newAffectedVirtualEntries,
        allAffectedVirtualEntriesSelected: newAllAffectedVirtualEntriesSelected
      };
    }

    case SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL:
      return {
        ...state,
        validationMessages: payload
      };

    default:
      return state;
  }
};

const tournamentReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL: {
      state.selected = (state.id === payload.tournamentId && payload.anySelected);
      return {
        ...state,
        entries: state.entries.map(x => entryReducer(x, {type, payload})),
        virtualEvents: state.virtualEvents.map(x => entryReducer(x, {type, payload}))
      };
    }
    case SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN:
      return state.id === payload.tournamentId
        ? {
          ...state,
          virtualEvents: state.virtualEvents.map(x => virtualEventReducer(x, {type, payload}))
        }
        : state;
    case SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN:
      return state.id === payload.tournamentId
        ? {
          ...state,
          entries: state.entries.map(x => entryReducer(x, { type, payload }))
        }
        : state;
    case SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN: {
      return state.id === payload.tournamentId
        ? {
          ...state,
          collapsed: !state.collapsed
        }
        : state;
    }
    default:
      return state;
  }
};

const entryReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL: {
      const isSelectable = state.tournamentId === payload.tournamentId || !payload.anySelected;

      return {
        ...state,
        selectable: isSelectable,
        hasBalance: state.balanceDue > 0
      };
    }
    case SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN: {
      return state.id === payload.entryId
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    }
    default:
      return state;
  }
};

const virtualEventReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN: {
      return state.virtualEventId === payload.virtualEventId
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    }
    default:
      return state;
  }
};

const paymentReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL: {
      return {
        ...state,
        displayEntries: state.paymentId === payload ? !state.displayEntries : false
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/reducer.js